import { EXPORT_PER_PAGE } from './const';

type PageResponse<T> = { meta: { last_page: number }; data: T[] };

export async function fetchAllPages<T>(
    fetchPage: (page: number, perPage: number) => Promise<PageResponse<T>>,
): Promise<T[]> {
    const first = await fetchPage(1, EXPORT_PER_PAGE);
    const rows = [...first.data];
    for (let page = 2; page <= first.meta.last_page; page += 1) {
        // eslint-disable-next-line no-await-in-loop
        const next = await fetchPage(page, EXPORT_PER_PAGE);
        rows.push(...next.data);
    }
    return rows;
}
